/**
 * Vesper Cross-Platform Storage Abstraction
 *
 * Web: initialized with localStorage (synchronous)
 * Mobile: initialized with AsyncStorage (async)
 *
 * All consumers must handle both sync and async returns.
 */

export interface IStorage {
  getItem(key: string): string | null | Promise<string | null>;
  setItem(key: string, value: string): void | Promise<void>;
  removeItem(key: string): void | Promise<void>;
}

let _storage: IStorage | null = null;
let _onAuthFailure: (() => void) | null = null;

export function initStorage(storage: IStorage): void {
  _storage = storage;
}

export function getStorage(): IStorage {
  if (!_storage) {
    throw new Error('[Vesper] Storage not initialized. Call initStorage() at app entry.');
  }
  return _storage;
}

export function setOnAuthFailure(callback: () => void): void {
  _onAuthFailure = callback;
}

export function getOnAuthFailure(): (() => void) | null {
  return _onAuthFailure;
}

/** Helper to resolve sync or async storage reads */
export async function resolveStorageValue(
  value: string | null | Promise<string | null>,
): Promise<string | null> {
  return value instanceof Promise ? value : value;
}
